var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevieResponseIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 20",
    width: 17,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 17,
    height: 20,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAMAAABcfiZ7AAAAAXNSR0IB2cksfwAAANJQTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////GP/UYgAAAEZ0Uk5TxfP8+eltAPrWma7/bv2LJ/VrkTJnoDSQX/Aq8QcSDgIvOqj7j730iv5jjoUUBAGt5+jUGXusmA+M+ELs97NPsoPCbMHS0whC6ZkAAACvSURBVHicVc3pGoFAFIDh06SJjuzKkiVCZAsh2Zf7vyVT6jG9P7/nLAACiYkZiTIgZ3MxBTEfFrVAY0UsYZkVUklKFWt1NsUVDfVGEyWutAgy7bAYHaZLe33TNAdDIBYdhb/HWjQ4sYHodDpjnHlULPV/Z2EYy1+x6Godcl13s42KTndebH9IbdHkjnpMFfbLV048T4QA0wI4X668mw+2k7pzRyCPJ+9F4C3IPOHzBcctHbBHLDj8AAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevieResponseIcon1);
export default __webpack_public_path__ + "static/media/revieResponseIcon1.6927a3ab09424ec1cd8ba9e15b575323.svg";
export { ForwardRef as ReactComponent };